module.exports = __webpack_public_path__ + "static/logo-f41bdd25cc1834f158134d77a075e965.svg";